var _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 604.1 72.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#575756}.cls-2{fill:#f8b265}.cls-3{fill:#f7b390}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 38v-.1a23 23 0 0123-23.5c8.9 0 13.5 3.2 17.8 7.2l-1 1a22.8 22.8 0 00-16.8-6.8 21.6 21.6 0 00-21.5 22v.1C15 50 24.1 60 36.4 60a23.4 23.4 0 0017-7.4l1.1 1a24.8 24.8 0 01-18.2 7.7A22.8 22.8 0 0113.4 38zM84.2 14.4h19.1c6.1 0 10.6 1.6 13.5 4.5a11.9 11.9 0 013.3 8.7v.1c0 7.9-6.2 12.6-15.3 13.1l15.6 20.5h-1.8L103 40.9H85.7v20.4h-1.5zm18.4 25.1c10.8 0 16-5.1 16-11.7v-.2c0-7.4-5.7-11.8-15.4-11.8H85.7v23.7zM153.2 14.4h1.5v46.9h-1.5zM189.1 14.4h16.5c11.4 0 18 5.3 18 14.1v.1c0 9.1-7 14.3-18.3 14.3h-14.7v18.4H189zm16.2 27.1c10.4 0 16.8-4.5 16.8-12.8v-.1c0-8-6.2-12.8-16.7-12.8h-14.8v25.7zM265.8 15.8h-17v-1.4h35.3v1.4h-16.9v45.5h-1.4zM326.3 13.7h-1.2l-22.8 47.6h1.6l6.7-14.2 15.1-31.5 15 31.5 6.8 14.2h1.6l-22.8-47.6zM378.4 14.4h1.3L415.3 59V14.5h1.4v46.8h-1.3l-35.6-44.4v44.4h-1.4z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M572.4 50.6h.7V60h-.7z",
    className: "cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M570.9 49.1h3.7v12.4h-3.7z",
    className: "cls-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M451.7 17h15C477 17 483 21.8 483 29.7v.2c0 8.2-6.3 12.9-16.6 12.9H453v16.7h-1.3zm14.7 24.6c9.4 0 15.2-4.1 15.2-11.7 0-7.3-5.6-11.7-15-11.7H453v23.4z",
    className: "cls-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M454.5 61h-4.3V15.5h16.4c11.2 0 17.9 5.3 17.9 14.2v.2c0 9-6.8 14.4-18.1 14.4h-11.9zm0-21h11.9c8.7 0 13.7-3.6 13.7-10v-.2c0-6.4-5-10.1-13.6-10.1h-12z",
    className: "cls-3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M518.3 17.5h-1.1l-20.3 42.4h1.4l6-12.6 13.4-28.1 13.4 28.1 6.1 12.6h1.4l-20.3-42.4z",
    className: "cls-2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M541 61.4h-4.8l-18.5-38.7-18.5 38.7h-4.7L516.2 16H519.3L541 61.4z",
    className: "cls-3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M572.3 49.3h.9L588.7 17h-1.1l-4.6 9.6L572.8 48l-10.2-21.4L558 17h-1.1l15.4 32.3z",
    className: "cls-2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M572.8 51.5l-.3-.7h-1.1l-16.9-35.3h4.4l13.9 29 13.9-29h4.3l-16.8 35.3h-1.1l-.3.7z",
    className: "cls-3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f3119853.svg";
export { ForwardRef as ReactComponent };